// import HttpConnection from './HttpConnection';
import WebsocketConnection from "./WebsocketConnection";

abstract class AbstractCommManager {
  abstract getConnectionStrategy(
    onReady: () => {},
    onClose: () => {}
  ): WebsocketConnection;
  abstract normalizeResponse(payload: any): void;
  abstract normalizeBroadcastResponse(payload: any): void;
  abstract appReload(): void;

  abstract rgsLogin(): void;
  abstract rgsInit(sessionID: any): void;
  abstract getHeartbeatPayload(): any;

  abstract buyBonus(): void;
  abstract updateBalance(): void;
  abstract placeBet(_numbers: any[]): void;
  abstract getBets(): void;
  abstract subscription(_numbers: any[], _subscriptions: number): void;
  abstract lastResults(): void;
  abstract failedBets(): void;
}

export default AbstractCommManager;
